if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.querySelectorAll('[data-media-step]').forEach((button) => {
          button.addEventListener('click', () => this.stepMedia(Number(button.dataset.mediaStep)));
        });
        this.addEventListener('keydown', (event) => {
          if (!this.hasAttribute('open') || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          if (event.target.closest('deferred-media, product-model, input, textarea, select')) return;
          event.preventDefault();
          this.stepMedia(event.key === 'ArrowRight' ? 1 : -1);
        });
      }

      hide() {
        super.hide();
      }

      show(opener) {
        this.openedBy = opener;
        this.showActiveMedia();
        super.show(opener);
        this.querySelector('[id^="ModalClose-"]').focus({ preventScroll: true });
      }

      showActiveMedia() {
        const requestedId = this.openedBy.getAttribute('data-media-id');
        const gallery = this.openedBy.closest('media-gallery');
        const galleryItems = gallery ? Array.from(gallery.querySelectorAll('[id^="GalleryViewer"] li[data-media-id]')) : [];
        const allMedia = Array.from(this.querySelectorAll('.product-media-modal__content > [data-media-id]'));
        this.media = allMedia.filter((media) => {
          const galleryItem = galleryItems.find((item) => item.dataset.mediaId.endsWith(`-${media.dataset.mediaId}`));
          return !galleryItem || !galleryItem.hidden;
        });
        this.activeIndex = Math.max(0, this.media.findIndex((media) => media.dataset.mediaId === requestedId));
        this.renderMedia();
      }

      stepMedia(direction) {
        if (!this.media?.length) return;
        window.pauseAllMedia();
        this.activeIndex = (this.activeIndex + direction + this.media.length) % this.media.length;
        this.renderMedia();
      }

      renderMedia() {
        const activeMedia = this.media[this.activeIndex];
        if (!activeMedia) return;
        this.querySelectorAll('.product-media-modal__content > [data-media-id]').forEach((media) => {
          const active = media === activeMedia;
          media.classList.toggle('active', active);
          media.hidden = !active;
          media.setAttribute('aria-hidden', String(!active));
          media.inert = !active;
        });
        this.querySelector('[data-media-current]').textContent = String(this.activeIndex + 1);
        this.querySelector('[data-media-total]').textContent = String(this.media.length);
        this.querySelectorAll('[data-media-step]').forEach((button) => {
          button.disabled = this.media.length < 2;
        });
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
